export interface GuestVoucherReportComponentProps {
    // No props needed — the report is self-contained
}

export const GuestVoucherReportComponent = {
    MountAsync: async (target: HTMLElement, props: GuestVoucherReportComponentProps) => {
        const { mountReactComponentAsync } = await import('../../../js/mountReactComponentAsync');
        const { GuestVoucherReportComponent } = await import('./GuestVoucherReportComponent');
        return await mountReactComponentAsync(target, GuestVoucherReportComponent, props);
    }
};
